export const TIPO_DESTINATARIO_OPERADOR = 'Operador';
export const TIPO_DESTINATARIO_SOLICITANTE = 'Solicitante';
export const TIPO_DESTINATARIO_PROFISSIONAL = 'Profissional';
export const TIPO_DESTINATARIO_OPERADORES_INTERNO = 'OperadoresInterno';

export const TIPO_DESTINATARIO_LABELS: Record<string, string> = {
    [TIPO_DESTINATARIO_OPERADOR]: 'Operador',
    [TIPO_DESTINATARIO_SOLICITANTE]: 'Solicitante',
    [TIPO_DESTINATARIO_PROFISSIONAL]: 'Profissional',
    [TIPO_DESTINATARIO_OPERADORES_INTERNO]: 'Operadores (interno)',
};

export const getTipoLabelDestinatario = (tipo: string): string => {
    return TIPO_DESTINATARIO_LABELS[tipo] ?? tipo;
};
